import { render, staticRenderFns } from "./c-view@.vue?vue&type=template&id=6df6a2d0&"
import script from "./c-view@.vue?vue&type=script&lang=ts&"
export * from "./c-view@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports